export default {
  message: '¡Listo! Ya guardamos tu nueva contraseña.',
  returnButton: 'Regresar a la App',
};
